(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("cornerstone-core"), require("dicom-parser"));
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneWADOImageLoader", ["jquery", "cornerstone-core", "dicom-parser"], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneWADOImageLoader"] = factory(require("jquery"), require("cornerstone-core"), require("dicom-parser"));
	else
		root["cornerstoneWADOImageLoader"] = factory(root["$"], root["cornerstone"], root["dicomParser"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition